import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=1438d0b2&scoped=true"
import script from "./Year.vue?vue&type=script&lang=js"
export * from "./Year.vue?vue&type=script&lang=js"
import style0 from "./Year.vue?vue&type=style&index=0&id=1438d0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438d0b2",
  null
  
)

export default component.exports